import { useEffect, useRef, useState } from 'react';

const useRerenderer = (time?: number) => {
  const ref = useRef<number | undefined>(undefined);
  const [t, setT] = useState<number | undefined>(undefined);

  useEffect(() => {
    if (time) {
      ref.current = setTimeout(() => setT(new Date().valueOf()), time) as unknown as number;

      return () => {
        if (ref.current) {
          clearTimeout(ref.current);
        }
      };
    }
  });

  return t;
};

export default useRerenderer;
